module.exports = __webpack_public_path__ + "img/header1.bda0c43b.webp";